<script setup lang="ts">
import { computed } from 'vue';
import type { FilterChip } from '@/types/browser';
import FilterChips from '@/components/data/grid/FilterChips.vue';
import FilterPopover from '@/components/atoms/element-filters/FilterPopover.vue';
import { useIsDesktop } from '@/composables/useMediaQuery';

const props = withDefaults(
  defineProps<{ label: string; chips: FilterChip[]; multiple?: boolean }>(),
  { multiple: false },
);
const emit = defineEmits<{ remove: [chip: FilterChip] }>();

const isDesktop = useIsDesktop();
// Single-value: offer the add affordance only when empty. Multi-value: always.
const showAdd = computed(() => props.multiple || props.chips.length === 0);
</script>

<template>
  <FilterChips v-if="chips.length" :chips="chips" @remove-chip="emit('remove', $event)" />
  <template v-if="showAdd">
    <FilterPopover v-if="isDesktop" :label="label">
      <slot />
    </FilterPopover>
    <div v-else class="filter-control-inline">
      <!-- The slotted field (FilterField) renders its own mobile label; a second
           label here duplicated it. Let the field own the single label. -->
      <slot />
    </div>
  </template>
</template>
